import React, { Suspense, lazy } from "react";
import { LoadingState } from "../../../components/UI/States";

// three.js is ~150 KB gzipped, so the designer is its own chunk: only people
// who open /tools/building-designer download it, not every page load.
const BuildingDesigner = lazy(() => import("./BuildingDesigner"));

const LazyBuildingDesigner = () => (
  <Suspense fallback={<LoadingState label="Loading the designer…" className="min-h-[60vh]" />}>
    <BuildingDesigner />
  </Suspense>
);

export default LazyBuildingDesigner;
